<template>
    <el-dialog
        :title="$t('message.cmember.diaTitle')"
        :visible="dialogVisible"
        @close="handleClose"
        width="70%"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <slot name="form" v-if="dialogVisible"></slot>
        <!-- 按钮 -->
        <template #footer>
            <div>
                <el-button
                    type="primary"
                    @click="handleModify">
                    <span>{{$t("public.confirmBtn")}}</span>
                </el-button>
                <el-button
                    @click="handleClose">
                    <span>{{$t("public.cancelBtn")}}</span>
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: mapState({
        dialogVisible: state => state.dialogVisible
    }),
    methods: {
        handleClose(){
            this.$emit('handleClose');
        },
        handleModify(){
            this.$emit('handleModify', this.handleClose);
        }
    }
}
</script>